import Vue            from 'vue';
import Router         from 'vue-router';
import Home           from './views/Home.vue';
import Location          from './views/Location.vue';
import LocationEdit      from './views/LocationEdit.vue';
import PersonEdit     from './views/PersonEdit.vue';
import Reports      from './views/Reports.vue';
import Settings       from './views/Settings.vue';

Vue.use(Router);

export default new Router({
  mode: 'hash',
  base: './',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      props: true
    },
    {
      path: '/reports',
      name: 'reports',
      component: Reports,
      props: true
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings,
      props: true
    },
    {
      path: '/people/:id/edit',
      name: 'personEdit',
      component: PersonEdit,
      props: true
    },
    {
      path: '/locations/:id/edit',
      name: 'locationEdit',
      component: LocationEdit,
      props: true
    },
    {
      path: '/locations/:id',
      name: 'location',
      component: Location,
      props: true
    }
  ]
});
